import { createThemeCompiler } from '../../../utils';

export const chartThemeCompiler = createThemeCompiler(({ palette }) => ({
    chart: {
        colors: {
            titleColor: palette.neutralPrimary
        },
        composites: {
            titlePadding: 10
        }
    }
}));
